// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportView_wrapper__c+Zyn","title":"SupportView_title__CyJKT","content":"SupportView_content__pq9mm"};